import React from "react";

import { EmptyText } from "@multiweb/reactComponents";
import { LLF_EMPTY_VALUE } from "../../../../constants";
import { PlaceholderComponent } from "../../types";

export const LiteListFrameEmptyAttributePlaceholder: PlaceholderComponent = ({
    interactive,
}) => <EmptyText content={LLF_EMPTY_VALUE} {...{ interactive }} />;
